import { render, staticRenderFns } from "./FeedbackBecomeAPartnerView.vue?vue&type=template&id=7528b607"
import script from "./FeedbackBecomeAPartnerView.vue?vue&type=script&lang=ts"
export * from "./FeedbackBecomeAPartnerView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports